import React from 'react';
import {
  Form,
} from 'antd';
import DropdownSearch from '../../../../algolia/DropdownSearch';

class ConsignerCustomerAccount extends React.Component {

  render() {
    const {
      updateState,
      values,
      queryKey,
      query,
      userId,
      disabled
    } = this.props;
    const {
      consignerName
    } = values;
    return (
      <div>
          <Form.Item >
            <DropdownSearch
              searchPlaceholder='Search Consigners'
              index='consigners'
              keyName='name'
              updateState={updateState}
              stateKey='consignerId'
              stateValue='objectID'
              stateKey2='consignerName'
              stateValue2='name'
              value={consignerName}
              query={query}
              queryKey={queryKey}
              userId={userId}
              viewOnly={disabled}

            />
          </Form.Item>
      </div>
    );
  }
}
export default ConsignerCustomerAccount;
